import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { UserImportCSVData, UserImportSelectedModel } from '../../setup/setup.component';
import { TranslateModule } from 'app/modules/translate.module';

@Component({
    selector: 'mon-user-import-confirm',
    imports: [
        CommonModule,
        TranslateModule,
    ],
    templateUrl: './user-import-confirm.component.html',
})
export class UserImportConfirmComponent {
    @Input() data: UserImportCSVData;
    @Input() selected: UserImportSelectedModel;

    isAdmin (user: string[]): boolean {
        const adminValue = user[this.selected?.isAdminIndex];
        return !!(adminValue && typeof adminValue === 'string' && adminValue.toLowerCase() === 'yes');
    }

    getUserValue (user: string[], index: number | undefined): string {
        return (index !== undefined && user[index]) ? user[index] : '';
    }
}
